import {
  filterEnglishNameList,
  filterEnglishNameTableSource,
  isGoFreightUser,
  syncGoFreightTableColumns
} from '@/utils/goFreight'

function wrapComponentData(options) {
  if (!isGoFreightUser()) return
  const originalData = options.data
  if (typeof originalData !== 'function' || originalData.__goFreightWrapped) return

  options.data = function goFreightWrappedData(...args) {
    const data = originalData.apply(this, args)
    if (data?.tableSource) {
      filterEnglishNameTableSource(data.tableSource)
    }
    if (Array.isArray(data?.baseInfo)) {
      data.baseInfo = filterEnglishNameList(data.baseInfo)
    }
    return data
  }
  options.data.__goFreightWrapped = true
}

export default {
  computed: {
    showEnglishNameField() {
      return !isGoFreightUser()
    }
  },
  beforeCreate() {
    wrapComponentData(this.$options)
  },
  created() {
    this.filterGoFreightEnglishNameFields()
  },
  mounted() {
    this.$nextTick(() => {
      this.filterGoFreightEnglishNameFields()
      syncGoFreightTableColumns(this)
    })
    this.$eventBus.$on('go-freight-permission-updated', this.onGoFreightPermissionUpdated)
  },
  activated() {
    this.$nextTick(() => {
      this.filterGoFreightEnglishNameFields()
      syncGoFreightTableColumns(this)
    })
  },
  beforeDestroy() {
    this.$eventBus.$off('go-freight-permission-updated', this.onGoFreightPermissionUpdated)
  },
  methods: {
    filterGoFreightEnglishNameFields() {
      if (!isGoFreightUser()) return
      if (this.tableSource) {
        filterEnglishNameTableSource(this.tableSource)
      }
      if (Array.isArray(this.baseInfo)) {
        this.baseInfo = filterEnglishNameList(this.baseInfo)
      }
    },
    onGoFreightPermissionUpdated() {
      this.filterGoFreightEnglishNameFields()
      this.$nextTick(() => {
        syncGoFreightTableColumns(this)
      })
    }
  }
}
